import $ from 'jquery';
import 'what-input';

window.jQuery = $;

//*********************************
// foundation
//*********************************
import './lib/foundation-explicit-pieces';

//*********************************
// aos
//*********************************
import './components/aos.js';

//*********************************
// slick-carousel
//*********************************
import './components/slick-carousel.js';

//*********************************
// keen-slider
//*********************************
import './components/keen-slider.js';

//*********************************
// masonry-isotope
//*********************************
import './components/masonry-isotope.js';

//*********************************
// lightbox
//*********************************
import './components/lightbox.js';

//*********************************
// logostripe.js
//*********************************
import './components/logostripe.js';

            
//*******************************
// init foundation
//*******************************

$(document).foundation();
